export default {
  LandingPage: {
    intro_sub:
      "Dai una seconda vita all'imballo e contribuisci a proteggere l'ambiente",
    title: 'Samsung Upcycle-Packaging',
    sequence1_1: 'Insieme, riduciamo gli sprechi e preserviamo',
    sequence1_2:
      "l'ambiente costruendo oggetti utili con la scatola del tuo prodotto",
    sequence2_1: 'Presentiamo il nuovo Samsung Upcycle-Packaging',
    sequence2_2:
      'Appositamente progettata per essere riutilizzata, ti consente di creare oggetti per la tua casa. Ecologica e utile!',
    sequence3_1:
      'Segui le linee tratteggiate stampate sulla confezione e ritaglia facilmente diversi pezzi',
    sequence3_2: "Devi solo assemblarli per ottenere l'oggetto desiderato",
    sequence4_1: 'Devi solo scegliere il tuo oggetto preferito',
    sequence4_2:
      'Scorri verso il basso e seleziona il prodotto che possiedi. Dai sfogo alla tua creatività',
    selectBox: 'Seleziona la tua prodotto.',
    moreActivity:
      'Scopri di più sulle attività per la sostenibilità di Samsung',
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame',
    theSerif: 'The Serif',
    theSero: 'The Sero',
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/it/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/it/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/it/sustainability/overview/',
    footer:
      'Copyright© 2019-2021 Samsung Electronics Italia S.p.A - P.I. 11325690151 - Tutti i diritti riservati.',
    // <br/>
    // Questo sito è ottimizzato per Internet Explorer 11, Chrome, Safari ed i browser più recenti.`
  },
  ProductPage: {
    selectDesign: 'Scegli il design',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'Console TV',
    StorageBox: 'Scatola',
    MagazineRack: 'Scatola per riviste',
    CatHouse: 'Cuccia per il gatto',
    CatTunnel: 'Tunnel per gatti',
    BookShelf: 'Libreria',
    DeskShelf: 'Mensola da libreria',
    BlackRhino: 'Endangered \n Animals \n Black Rhino', //update
    PolarBear: 'Endangered \n Animals \n Polar Bear', //update
    SeaTurtle: 'Endangered \n Animals \n Sea Turtle', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Alex Couch \n Arm Table', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Kinoko table', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Postcard \n Planter', //update
    SneakerRack: 'Sneaker \n Rack', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Tool Box', //update
    DeskStationary: 'Portaoggetti per cancelleria',
    CoinBank: 'Salvadanaio',
    MobileScanner:'Supporto per scanner smartphone',
    TabletScanner:'Supporto per scanner tablet',
    PetStairs:'Scale per animali domestici',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'minuti',
    all:'ALL',
    in: 'pollici',
    inOnly: 'solo in pollici',
    allBoxSize: 'Tutte le dimensioni delle scatole',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'Istruzioni',
    prepare: 'Prepara la scatola',
    LetsDesign: 'Iniziamo a costruire?',
    drawParts: 'Prova a disegnare delle parti sulla scatola.',
    note1:
      'La posizione grafica potrebbe variare in base al paese e alle dimensioni della scatola',
    note2: 'Per iniziare, fai una bozza che entri nello spazio della scatola',
    numberSpace: 'numero = spazio fra i punti',
    diagonal: 'diagonale',
    LEFT: 'sinistra',
    RIGHT: 'destra',
    TOP: 'alto',
    TOP1: 'alto 1',
    TOP2: 'alto 2',
    BACK: 'retro',
    MIDDLE: 'centro',
    MIDDLE2: 'centro 2',
    BOTTOM: 'basso',
    FRONT: 'fronte',
    SIDE: 'lato',
    secondSIDE: 'secondo lato',
    secondSIDE1: 'secondo lato 1',
    secondSIDE2: 'secondo lato 2',
    LEG: 'GAMBA', //update
    JOINT: 'GIUNTURA', //update
    FACE: 'VISO', //update
    DRAWERBOTTOM: 'BASE CASSETTO', //update
    DRAWERSIDE: 'LATO CASSETTO', //update
    NOSE: 'NASO', //update
    HANDLE: 'MANIGLIA', //update
    BOTTOMSIDE: 'LATO INFERIORE', //update
    TOPSIDE: 'LATO SUPERIORE', //update
    WING: 'ALA', //update
    cutAndAssemble: 'Taglia e assembla',
    beCareful: 'Fai attenzione a non ferirti mentre usi il taglierino',
    cutOutParts: 'Taglia le parti',
    assemble: 'Assembla',
    Assemblyguide: 'Manuale per il montaggio', //update
    fold: 'Esempio pieghevole',
    foldGuide: 'Usa il bordo dei mobili quando pieghi il cartone',
    foldGuideDezeen:
      'Premi con uno strumento sulla linea punteggiata del cartone per piegarlo',
    glue: 'applicare la colla o il nastro in modo uniforme sulla superficie', //update
    cable: 'Usa fascette o stringhe per la connessione', //update
    done: 'Fatto!',
    goBack: 'Torna al menù principale',
  },
  CautionPage: {
    CAUTION: 'Attenzione',
    needItem: 'Ti servono gli strumenti illustrati',
    children: 'I bambini devono essere assistiti da un adulto',
    mat: 'Stendi un tappeto sul pavimento per evitare graffi',
    doNotPutHeavyThing:
      'Non schiacciare, sedersi e posare oggetti pesanti sui mobili',
    doNotThrow: 'Non lanciare o calciare i mobili verso persone o animali',
    stayAwayFlame: 'Tenere lontano dal fuoco',
    stayAwayWater: "Tenere lontano dall'acqua e da fonti di umidità",
    mayDamaged:
      '* La scatola per la TV potrebbe essere danneggiata durante la spedizione.',
    companyDoestResponsible:
      "* L'azienda non si assume alcuna responsabilità per eventuali danni a cose o persone.",
    cannotBeReturned:'',
    understand: 'Si, capisco',
  },
  PrivacyPolicy: {
    title: 'Politica sulla riservatezza',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'Ci stiamo impegnando sempre più nella sostenibilità con il nostro nuovo packaging ecologico.',
      text2:
        "Abbiamo usato meno carta e inchiostro per la scatola del TV, che può essere trasformata in un elemento d'arredo.",
      text2_special:'',
      text3: 'Seleziona i bottoni in basso per saperne di più.',
    },
    greenIn: {
      title: 'Going Green nel packaging TV',
      subtitle1: 'Informazioni prodotto senza inchiostro',
      subtitle2: 'Upcycling Eco-package',
      desc: 'Cerca il nome del modello per avere più informazioni',
      descM: '*Take a photo of the TV model number',
      guide: 'Nome modello',
      button: 'Take Photo',
      button2: 'Costruisci',
    },
    search: {
      guide: 'Search..',
      noResult: 'Nessun risultato',
      more: 'Scopri di più',
    },
  },
  searchCountrySelect: 'Seleziona un paese in cui cercare'
};
